<template>
  <div>
    <p class="mb-3 text-women-text o-heading-4" v-text="title" />
    <div class="otable border-1 border-neutral-200 overflow-x-auto">
      <table class="o-body w-full text-center" :class="tableClass">
        <slot />
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OTable',
  props: {
    title: {
      type: String,
      default: 'Bralette'
    },
    tableClass: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped lang="postcss">
.otable {
  border-radius: .8rem;
  max-width: 100%;
  -webkit-overflow-scrolling: touch;

  >>> {
    thead {
      @apply bg-neutral-50;

      tr {
        th {
          @apply font-semibold py-4;

          &:first-child {
            @apply border-r border-neutral-200;
          }
        }
      }
    }

    tbody {
      td {
        @apply py-4 border-t border-neutral-200 px-2;

        &:first-child {
          @apply font-semibold border-r border-neutral-200 bg-neutral-50 border-t-0;
        }
      }
    }
  }
}
</style>
